import { Box } from '@zillow/constellation-10';
import { MessageListSkeleton } from '../MessageList/skeleton';
import { ConversationListSkeleton } from '../ConversationList/skeleton';
import ConversationNavSkeleton from '../ConversationNav/Skeleton';
import { columnWrapperStyles, primaryColumnStyles, secondaryColumnStyles } from '../../styles/inboxPageStyle';

export default function InboxSkeleton({
  shouldHideConversationListOnMobile,
}: {
  shouldHideConversationListOnMobile?: boolean;
}) {
  return (
    <Box css={columnWrapperStyles} aria-label="loading" role="status">
      <Box
        css={{
          ...primaryColumnStyles,
          display: shouldHideConversationListOnMobile ? { base: 'none', xl: 'flex' } : 'flex',
        }}
      >
        <ConversationListSkeleton />
      </Box>

      <Box
        css={{
          ...secondaryColumnStyles,
          display: !shouldHideConversationListOnMobile ? { base: 'none', xl: 'flex' } : 'flex',
        }}
      >
        <Box css={{ borderBottom: '1px solid', borderBottomColor: 'border.subtle', paddingBlock: 'default' }}>
          <ConversationNavSkeleton />
        </Box>
        <Box css={{ padding: 'default' }}>
          <MessageListSkeleton />
        </Box>
      </Box>
    </Box>
  );
}
